import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const NoAnswerIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-noAnswer"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M34,1 C27.9247153,1 23,5.92471525 23,12 C23,18.0752847 27.9247153,23 34,23 C40.0752847,23 45,18.0752847 45,12 C45,5.92471525 40.0752847,1 34,1 Z M34,3 C38.9707153,3 43,7.02928475 43,12 C43,16.9707153 38.9707153,21 34,21 C29.0292847,21 25,16.9707153 25,12 C25,7.02928475 29.0292847,3 34,3 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          points="36.828 7.757 38.243 9.172 31.172 16.243 29.757 14.828"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          points="31.172 7.757 38.243 14.828 36.828 16.243 29.757 9.172"
        />
        <path
          d="M44.7071,30.7929 C42.6311,28.3169 39.8031,26.4149 36.6071,25.7699 C33.5471,25.1539 30.3791,25.6619 27.6441,27.1609 C25.9771,28.0749 24.5111,29.3399 23.2931,30.7929 C22.4711,31.7729 23.8791,33.1949 24.7071,32.2069 C27.0381,29.4279 30.3031,27.4999 34.0001,27.4999 C37.6971,27.4999 40.9621,29.4279 43.2931,32.2069 C44.1211,33.1949 45.5291,31.7729 44.7071,30.7929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
